module.exports = "/images/icon_06.png?059cae8abad2e48af4c0dcb6aa6aecc5";